"use client";
import { ExternalLink } from "lucide-react";
import { DrupalNode } from "next-drupal";
import Link from "next/link";
import { FiPlusCircle } from "react-icons/fi";

interface FlipFlopCardProps {
  data: DrupalNode;
}

const FlipFlopCard: React.FC<FlipFlopCardProps> = ({ data }) => {
  const {
    title = "",
    field_button_text = "",
    field_link = "",
    field_content = {},
  } = data;

  return (
    <div className="flip-card relative">
      <div className="px-2.5 py-10 relative min-h-[220px] cursor-pointer flip-flop-card-box">
        <div className="card-front-flop rounded-[15px] px-2.5 py-10 h-full w-full absolute top-0 left-0 bg-[linear-gradient(to_bottom,#216988,#003350)]">
          <p className="--font-poppins text-[27px] leading-normal text-[#fff] text-center">
            {title}
          </p>
          <FiPlusCircle className="absolute bottom-2 right-2.5 text-white text-[35px]" />
        </div>
        <div className="card-back-flop rounded-[15px] px-6 py-8 h-full w-full absolute top-0 left-0 bg-[linear-gradient(to_bottom,#216988,#003350)] flex flex-col">
          <div
            dangerouslySetInnerHTML={{ __html: field_content?.processed }}
            className="--font-poppins text-xsmall leading-normal text-white text-center mb-5 line-climp-6 h-full"
          />
          <Link
            href={field_link}
            className="--font-poppins text-center text-xsmall text-[#fff] leading-6 flex items-center justify-center h-full"
          >
            <ExternalLink className="w-[16px] h-[16px] max-w-[16px] mr-2" />
            {field_button_text}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FlipFlopCard;
